import type { FC, ReactNode } from 'react'
import type { Agent } from '@/types'

import { cn } from '@/lib/utils'
import { Photo } from '@/components/generals/photo'

interface AgentAvatarProps {
    agent: Pick<Agent, 'name' | 'photo' | 'photo_alt'>
    className?: string
    sizes?: string
}

export const AgentAvatar: FC<AgentAvatarProps> = ({ agent, className, sizes = '96px' }): ReactNode => {
    const initials = agent.name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part[0]?.toUpperCase())
        .join('')

    return (
        <span className={cn('relative block shrink-0 overflow-hidden rounded-full bg-brand-soft', className)}>
            {agent.photo
                ? <Photo src={agent.photo} alt={agent.photo_alt || `Portrait of ${agent.name}`} sizes={sizes} />
                : (
                    <span className='absolute inset-0 flex items-center justify-center font-semibold text-primary' aria-hidden='true'>
                        {initials}
                    </span>
                )}
        </span>
    )
}
